import getValueFromQueryParams from "../utils/parse-query-params";
import fetchGraphql from "../utils/graphql";
import fetchShowroomApi from "../utils/fetch-showroom-api";

customElements.component = 'showroom-select-dresses';

if (!customElements.get(customElements.component)) {
  const selectors = {
    html: "html",
    loader: ".js-loader",
    content: ".js-showroom-select-dresses__content",
    deleteButton: ".js-showroom-product-card-delete",
    slider: ".js-showroom-select-dresses__slider",
    modal: ".js-modal",
    modalInner: ".js-modal-inner",
    modalClose: ".js-close-modal",
    modalHow: ".js-modal-how",
    modalHowTrigger: ".js-modal-trigger",
    visible: "visible"
  }

  class ShowroomSelectDresses extends HTMLElement {
    constructor() {
      super();

      this.html = document.querySelector(selectors.html);
      this.loader = this.querySelector(selectors.loader);
      this.content = this.querySelector(selectors.content);
      this.modals = this.querySelectorAll(selectors.modal);
      this.modalClose = this.querySelectorAll(selectors.modalClose);
      this.modalHow = this.querySelector(selectors.modalHow);
      this.modalHowTrigger = document.querySelector(selectors.modalHowTrigger);
      this.translations = window.showroom_select_dresses_t;
      this.icons = window.showroom_select_dresses_icons;
      this.allProducts = [];

      this.productByHandleQuery = `
        query ProductByHandle($handle: String!) {
          productByHandle(handle: $handle) {
            id
            availableForSale
            handle
            title
            vendor
            images(first: 250) {
              nodes {
                url,
                altText
              }
            }
            variants(first: 50) {
              nodes {
                id
                availableForSale
                title
                selectedOptions {
                  name
                  value
                }
                image {
                  url
                }
                price {
                  amount
                }
                compareAtPrice {
                  amount
                }
              }
            }
          }
        }
      `
      this.data = {}

      this.init();
    }

    handleModalCloseOutside(e, modal) {
      const modalInner = modal.querySelector(selectors.modalInner);

      if (!modalInner.contains(e.target)) {
        this.closeModal(modal);
      }
    }

    openModal(el) {
      this.html.classList.add("overflow-hidden");
      el.classList.add("opened");
    }

    closeModal(el) {
      this.html.classList.remove("overflow-hidden");
      el.classList.remove("opened");
    }

    async getData() {
      const showroomId = getValueFromQueryParams("id") || window.localStorage.getItem("last_viewed_showroom");

      if (showroomId) {
        this.data = await fetchShowroomApi(`/showrooms/${showroomId}`);

        const url = new URL(window.location);

        url.searchParams.set("id", this.data.id);
        window.history.pushState({}, '', url);

        window.localStorage.setItem("last_viewed_showroom", showroomId);

        if (!this.data.currentCustomerIsOwner) {
          this.modalHowTrigger.classList.add("hidden");
        }
      } else if (!window.is_customize) {
        window.location.pathname = "/pages/showroom"
      }
    }

    async getProducts() {
      const productsHandles = [];
      const requests = [];

      this.data.bridesmaids.forEach(bridesmaid => {
        if (bridesmaid.bridesmaidsDresses) {
          bridesmaid.bridesmaidsDresses.forEach(dress => {
            const { shopifyProductHandle } = dress;

            if (!productsHandles.includes(shopifyProductHandle)) {
              productsHandles.push(shopifyProductHandle)
            }
          });
        }
      })

      productsHandles.forEach(handle => {
        requests.push(
            fetchGraphql({
              query: this.productByHandleQuery,
              variables: {
                handle: handle
              }
            })
        );
      })

      const results = await Promise.all(requests);

      results.forEach(result => {
        if (result && result.data.productByHandle) {
          const { productByHandle } = result.data;
          this.allProducts.push(productByHandle)
        }
      });
    }

    renderLayout() {
      this.data.bridesmaids.forEach((obj, index) => {
        if (obj.bridesmaidsDresses.length) {
          const objProducts = [];

          obj.bridesmaidsDresses.forEach(dress => {
            this.allProducts.forEach(product => {
              const variantImage  = product.images.nodes.filter(img => img.altText && img.altText.includes(dress.dressColor))[0] || null;
              let isVariantAdded = false;

              if (product.handle === dress.shopifyProductHandle) {
                product.variants.nodes.forEach(variant => {
                  variant.selectedOptions.forEach(option => {
                    if (option.value === dress.dressColor && !isVariantAdded) {
                      objProducts.push({
                        ...product,
                        variant,
                        variantImage,
                        color: option.value
                      });

                      isVariantAdded = true;
                    }
                  })
                })
              }
            })
          })

          this.content.innerHTML += `
            <div class="showroom-select-dresses__top">
                <div class="showroom-select-dresses__number">${index + 1}</div>
                <div>
                    <div class="showroom-select-dresses__role">${this.translations.bridesmaid}</div>
                    <div class="showroom-select-dresses__name">${obj.name || "Name"}</div>
                </div>
            </div>
            <div class="swiper showroom-select-dresses__slider js-showroom-select-dresses__slider" data-slides-count="${objProducts.length}" data-slider-id="${obj.id}">
                <div class="swiper-wrapper">
                    ${objProducts.map(product => {
                      return `<div class="swiper-slide">${this.renderProductCard(product, obj.id, product.color)}</div>`
                    }).join("")}
                    ${this.data.currentCustomerIsOwner ? `<div class="swiper-slide">${this.renderAddCard()}</div>` : ""}
                </div>
                ${objProducts.length ? `
                  <div class="swiper-button-prev"></div>
                  <div class="swiper-pagination"></div>
                  <div class="swiper-button-next"></div>
                ` : ``}
            </div>
          `
        } else {
          this.content.innerHTML += `
            <div class="showroom-select-dresses__top">
                <div class="showroom-select-dresses__number">${index + 1}</div>
                <div>
                    <div class="showroom-select-dresses__role">${this.translations.bridesmaid}</div>
                    <div class="showroom-select-dresses__name">${obj.name || "Name"}</div>
                </div>
            </div>
            <div class="swiper showroom-select-dresses__slider js-showroom-select-dresses__slider" data-slider-id="${obj.id}">
                <div class="swiper-wrapper">
                    ${this.data.currentCustomerIsOwner ? `<div class="swiper-slide">
                        ${this.renderAddCard()}
                    </div>` : `<div class="swiper-slide">${this.renderEmptyCard()}</div>`}
                </div>
            </div>
          `
        }
      })
    }

    renderProductCard(product, bridesmaidId, color) {
      if (product) {
        return `
          <div class="showroom-product-card">
            <div class="showroom-product-card-image">
                <img src="${product.variantImage ? product.variantImage.url : product.images.nodes[0].url}" alt="${product.title}">
                ${this.data.currentCustomerIsOwner ? `<div
                    class="showroom-product-card-delete js-showroom-product-card-delete"
                    data-bridesmaid-id="${bridesmaidId}"
                    data-product-handle="${product.handle}"
                    data-product-color="${color}"
                >${this.icons.delete}</div>`: ''}
                <a href="/products/${product.handle}" class="showroom-product-card-button">${product.availableForSale ? this.translations.buy : this.translations.sold_out}</a>
            </div>
            <div class="showroom-product-card-vendor">${product.vendor}</div>
            <div class="showroom-product-card-title">${product.title}</div>
            <div class="showroom-product-card-price">$${product.variant.price.amount}</div>
          </div>
        `
      }
    }

    renderAddCard() {
      return `
        <a href="/collections/bridesmaid" class="showroom-product-card showroom-select-dresses__add">
            ${this.icons.plus}
            <span>${this.translations.add}</span>
        </a>
      `
    }

    renderEmptyCard() {
      return `
        <div class="showroom-empty-card">
            ${this.icons.dress}
            ${this.translations.noSelected}
        </div>
      `
    }

    initSliders() {
      this.sliders = this.querySelectorAll(selectors.slider);

      this.sliders && this.sliders.forEach(slider => {
        const sliderID = slider.getAttribute("data-slider-id");
        const slidesCount = slider.getAttribute("data-slides-count");

        this.initSlider(`${selectors.slider}[data-slider-id="${sliderID}"]`, slidesCount);
      })
    }

    initSlider(selector, totalCount) {
      new Swiper(selector, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 24,
        navigation: {
          nextEl: `${selector} .swiper-button-next`,
          prevEl: `${selector} .swiper-button-prev`
        },
        pagination: {
          el: ".swiper-pagination",
          type: "fraction"
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            slidesPerGroup: 1,
          },
          991: {
            slidesPerView: 4,
            slidesPerGroup: 1,
          }
        }
      });
    }

    initEvents() {
      this.deleteButtons = this.querySelectorAll(selectors.deleteButton);

      this.deleteButtons && this.deleteButtons.forEach(button => {
        button.addEventListener("click", async () => {
          const bridesmaidId = button.getAttribute("data-bridesmaid-id");
          const productHandle = button.getAttribute("data-product-handle");
          const productColor = button.getAttribute("data-product-color");

          const body = {
            "dressHandle": productHandle,
            "dressColor": productColor,
            "bridesmaidIds": [
              bridesmaidId
            ]
          }

          await fetchShowroomApi(`/showrooms/${this.data.id}/dresses`, "DELETE", JSON.stringify(body));

          window.location.reload();
        })
      })

      this.modals && this.modals.forEach(modal => {
        modal.addEventListener("click", e => this.handleModalCloseOutside(e, modal))
      })

      this.modalClose && this.modalClose.forEach(el => {
        el.addEventListener("click", () => this.closeModal(el.closest(selectors.modal)))
      })

      this.modalHowTrigger && this.modalHowTrigger.addEventListener("click", () => this.openModal(this.modalHow))
    }

    async init() {
      await this.getData();
      await this.getProducts();
      this.renderLayout();
      this.initSliders();
      this.initEvents();

      this.loader.classList.remove(selectors.visible);
    }
  }

  customElements.define(customElements.component, ShowroomSelectDresses);
}
